import React, { Component } from 'react'
import i18n from '../i18n.json'

class KeywordsSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedKeywords: this.props.newLogo.userPrefs.selectedKeywords,
      replaceIndex: 0
    }
  }

  componentDidMount() {
    // if (this.refs['keyword0']) {
    //   // Need a small delay to complete CSSTransitionGroup
    //   setTimeout(() => { this.refs['keyword0'].focus() }, 500)
    // }
  }

  handleKeywordChange(index, e) {
    if (!e) return
    if (!e.target) return
    let {value} = e.target
    let updated = this.state.selectedKeywords
    updated[index] = value
    this.setState({
      selectedKeywords: updated
    })
    this.props.updateSelectedKeywords({
      selectedKeywords: updated
    })
  }

  onCheckboxClick(evt, selected) {
    evt.preventDefault()
    let { selectedKeywords } = this.state
    let updated = selectedKeywords

    if (!updated.includes(selected)) {
      let inserted = false
      for (let index = 0; index < updated.length; index ++) {
        if (updated[index] === "" && !inserted) {
          updated[index] = selected
          inserted = true
        }
      }
      if (!inserted) {
        updated[this.state.replaceIndex] = selected
        let newIndex = this.state.replaceIndex + 1
        if (newIndex >= updated.length) newIndex = 0
        this.setState({
          replaceIndex: newIndex
        })
      }
    } else {
      updated = updated.map(item => {
        if (item === selected) return ""
        else return item
      })
    }
    this.setState({
      selectedKeywords: updated
    })
    this.props.updateSelectedKeywords({
      selectedKeywords: updated
    })
  }

  renderContent() {
    let { availableSector } = this.props.newLogo
    if (!availableSector) return
    if (!this.props.newLogo.availableSector) return
    if (this.props.newLogo.availableSector.length <= 0) return

    let { selectedLanguage } = this.props.newLogo.userPrefs
    let sector = this.props.newLogo.userPrefs.selectedSector[0]
    let selectedSector = this.props.newLogo.availableSector.find(item => item.uid === sector)
    if (!selectedSector) selectedSector = this.props.newLogo.availableSector.find(item => item.name === "Other")
    let defaultKeywords = selectedSector.keywords
    if (selectedLanguage === 'pt' && defaultKeywords['pt_br']) defaultKeywords = defaultKeywords['pt_br']
    else if (defaultKeywords[selectedLanguage]) defaultKeywords = defaultKeywords[selectedLanguage]

    let stylesJSX = defaultKeywords.map((data) => {
      let selectionStatus = this.props.newLogo.userPrefs.selectedKeywords.includes(data) ? 'selected' : 'not-selected'
      let name = data
      return (
        <li key={ "default-keyword-card-" + data }>
          <a href={ "/select_keyword/" + data } onClick={ (evt) => { this.onCheckboxClick(evt, data) } } >
            <label className={ selectionStatus }> { name } </label>
          </a>
        </li>
      )
    })

    return stylesJSX
  }

  render() {
    let { selectedLanguage } = this.props.newLogo.userPrefs

    return (
      <div className="fullpage">
        <div className="flex-row">
           <div className="page-description">
             <h1>
               { i18n[selectedLanguage]['step-keywords-title-part1'] }<br />
               <span className="title-cta-green">
               { i18n[selectedLanguage]['step-keywords-title-cta'] }
               </span><br />
               { i18n[selectedLanguage]['step-keywords-title-part2'] }
             </h1>

             <p>
                { i18n[selectedLanguage]['step-keywords-description'] }
             </p>

             <div className="keywords-inputs">
               <input
                 ref="keyword0"
                 name="keyword0"
                 value={this.state.selectedKeywords[0]}
                 onChange={this.handleKeywordChange.bind(this, 0)}
                 type="text"
                 className="form-control"
                 placeholder={ i18n[selectedLanguage]['step-keywords-placeholder1'] }
                 />
               <input
                 ref="keyword1"
                 name="keyword1"
                 value={this.state.selectedKeywords[1]}
                 onChange={this.handleKeywordChange.bind(this, 1)}
                 type="text"
                 className="form-control"
                 placeholder={ i18n[selectedLanguage]['step-keywords-placeholder2'] }
                 />
               <input
                 ref="keyword2"
                 name="keyword2"
                 value={this.state.selectedKeywords[2]}
                 onChange={this.handleKeywordChange.bind(this, 2)}
                 type="text"
                 className="form-control"
                 placeholder={ i18n[selectedLanguage]['step-keywords-placeholder3'] }
                 />
             </div>
           </div>
           <div className="page-content">
             <ul className="page-content-list-keywords">
                  { this.renderContent() }
             </ul>
           </div>
        </div>
      </div>
    )
  }
}

export default KeywordsSelector



// WEBPACK FOOTER //
// ./src/components/KeywordsSelector.js